import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  container: {
    marginBottom: 32,
    padding: 24,
    border: "1px solid #e0e0e0",
    borderRadius: 8,
  },
  header: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  resultText: {
    fontSize: 24,
    fontWeight: "bold",
    margin: "0 0 8px 0",
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  correct: {
    color: "#22c55e",
  },
  incorrect: {
    color: "#ef4444",
  },
  subtitle: {
    fontSize: 16,
    color: "#000",
    margin: "0 0 20px 0",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 16,
  },
  gridItem: {
    padding: 16,
    borderRadius: 2,
    textAlign: "center",
    fontSize: 18,
    fontWeight: 500,
  },
  correctAnswer: {
    backgroundColor: "#dcfce7",
  },
  wrongAnswer: {
    backgroundColor: "#fee2e2",
  },
});
